import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="toggle-laboratorio"
export default class extends Controller {
  static targets = ['checkbox']
  static values = {
    url: String
  }

  toggle(e) {
    e.preventDefault();

    get(this.urlValue, {
      responseKind: 'turbo-stream',
      query: {
        completo: this.checkboxTarget.checked
      }
    })
  }
}
